import { observer } from 'mobx-react';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { Table } from '../../../components';
import { DATE_YMD } from '../../../core/configs/constants';
import { useStore } from '../../../core/utils/hook';
import moment from 'moment';
import { APPLY_CERT_STATUS_CONFIG, USER_CURRICULUM_STATUS, USER_CURRICULUM_STATUS_CONFIG } from '../../../core/configs/ei.constants';
import { DonutChart } from '../../Home/components/FirstTest';
import { flowResult } from 'mobx';

const EiTestHistoryByStudentScreen = observer(() => {

    // params, query
    const { id } = useParams();

    const [averageScore, setAverageScore] = useState(undefined);


    // store
    const {
        groupAdminStore: {
            testHistoriesByStudent,
            pagingTestHistoriesByStudent,
            getTestHistoriesByStudent,
            // getCalculateAverageEi,
            setAttrObservable
        }
    } = useStore();

    // lifecycle
    useEffect(() => {
        if (id) {
            getTestHistoriesByStudent({
                id
            });
            // onFetchCalculateAverageEi(id);
        }
    }, [id])

    // columns
    const columns = [
        {
            Header: 'No.',
            accessor: '',
            disableSortBy: true,
            Cell: ({ row: { original, index } }) => {
                const { page, size } = pagingTestHistoriesByStudent;
                return index + 1 + (size * (page - 1));
            },
            width: '50'
        },
        {
            Header: '教材名',
            accessor: 'curriculumName',
            disableSortBy: true,
            Cell: ({ row: { original } }) => {
                return (
                    <div style={{ wordBreak: 'break-all' }}>{original?.curriculumName || '--'}</div>
                );
            },
            width: '200'
        },
        {
            Header: '受検ステータス',
            accessor: 'status',
            disableSortBy: true,
            Cell: ({ row: { original } }) => {
                // eslint-disable-next-line max-len
                const isStatusValid = original?.status !== null && original?.status !== undefined;
                const cvStatus = isStatusValid ?
                    USER_CURRICULUM_STATUS_CONFIG?.[Number(original?.status)] :
                    null;
                const text = cvStatus?.label || '--';

                return (
                    <div style={{
                        fontWeight: 500
                    }}>
                        {text}
                    </div>
                );
            },
            width: '140'
        },
        {
            Header: '受検完了日',
            accessor: 'completionDate',
            disableSortBy: true,
            Cell: ({ row: { original } }) => {
                return (
                    <div>
                        {original?.completionDate ? moment(original.completionDate).format(DATE_YMD) : '--'}
                    </div>
                );
            },
            width: '160'
        },
        {
            Header: 'テスト結果',
            accessor: 'latestScore',
            disableSortBy: true,
            Cell: ({ row: { original } }) => {
                const score = original?.latestScore;
                const textScore = score !== null && score !== undefined ? `${score || 0}%` : '--';
                return (
                    <div>{textScore}</div>
                );
            },
            width: '100'
        },
        {
            Header: '単位申請状況',
            accessor: 'applyCertStatus',
            disableSortBy: true,
            Cell: ({ row: { original } }) => {
                const isApplyCertStatusValid = original?.applyCertStatus !== null &&
                    original?.applyCertStatus !== undefined &&
                    original?.applyCertStatus?.toString() !== '';
                const cvApplyCertStatus = isApplyCertStatusValid ?
                    APPLY_CERT_STATUS_CONFIG?.[Number(original?.applyCertStatus)] :
                    null;
                const text = original?.status === USER_CURRICULUM_STATUS.COMPLETED ? cvApplyCertStatus?.label || '--' : '--';
                return (
                    <div>{text}</div>
                );
            },
            width: '180'
        },
        {
            Header: '申請単位の認定種別',
            accessor: 'creditType',
            disableSortBy: true,
            Cell: ({ row: { original } }) => {
                return (
                    <div>
                        <span
                            style={{
                                color: '#FFFFFF',
                                backgroundColor: '#09AA6E',
                                fontWeight: 400,          // font-normal
                                lineHeight: 1,            // leading-none
                                display: 'inline-block',  // inline-block
                                borderRadius: '30px',     // rounded-[30px]
                                padding: '6px 12px'      // py-[6px] px-3 (px-3 = 12px)
                            }}
                        >研修</span>
                    </div>
                );
            },
            width: '160'
        }
    ]

    // functions
    // const onFetchCalculateAverageEi = async (id) => {
    //     const res = await flowResult(getCalculateAverageEi({
    //         id
    //     }))
    //     if (res) {
    //         setAverageScore(res?.averageScore || 0)
    //     }
    // }

    const onFetchData = async (tableData) => {
        setAttrObservable('pagingTestHistoriesByStudent', tableData, true, false);

        await flowResult(getTestHistoriesByStudent({
            id
        }))
    };

    return (
        <div id='main' className='wrapper main-student-list main-view-student-detail main-content-home-2 pd-b-50'>
            <section className='content-student-list'>
                <div className='container w-full'>
                    {/* <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        gap: 16
                    }}>
                        <DonutChart
                            percent={averageScore}
                            size={150}
                            thickness={0.8}
                        />

                        <div style={{ fontWeight: 600, fontSize: 16 }}>テスト正答率平均値（初回）</div>
                    </div> */}

                    <Table
                        columns={columns}
                        data={testHistoriesByStudent || []}
                        disablePaging={false}
                        disableSelectionPageSize={true}
                        scrollHorizontalWidth={'1400px'}
                        className='lst-attendance-table mg-t-35'
                        initialTableState={pagingTestHistoriesByStudent}
                        enableServerSidePaging={true}
                        onFetch={onFetchData}
                    />
                </div>
            </section>
        </div>

    )
})

export default EiTestHistoryByStudentScreen;